import * as Models from "../../_models";
/* NgRx */
import { createAction, props } from '@ngrx/store';


export const loadMateriasSuccess = createAction(
  '[FiltroBuscar API] Load Materias Success',
  props<{ materias: Models.MateriaMin[] }>()
);

export const loadMateriasFailure = createAction(
  '[FiltroBuscar API] Load Materias Fail',
  props<{ error: string }>()
);

export const loadMateriasMcpSuccess = createAction(
  '[FiltroBuscar API] Load Materias MCP Success',
  props<{ materiasMcp: Models.MateriaMin[] }>()
);

export const loadMateriasMcpFailure = createAction(
  '[FiltroBuscar API] Load Materias MCP Fail',
  props<{ error: string }>()
);

export const loadCursosSuccess = createAction(
  '[FiltroBuscar API] Load Cursos Success',
  props<{ cursos: Models.CursoDto[] }>()
);

export const loadCursosFailure = createAction(
  '[FiltroBuscar API] Load Cursos Fail',
  props<{ error: string }>()
);

export const loadPeriodosSuccess = createAction(
  '[FiltroBuscar API] Load Periodos Success',
  props<{ periodos: Models.Periodo[] }>()
);

export const loadPeriodosFailure = createAction(
  '[FiltroBuscar API] Load Periodos Fail',
  props<{ error: string }>()
);

export const loadSesionesSuccess = createAction(
  '[FiltroBuscar API] Load Sesiones Success',
  props<{ sesiones: Models.SesionDto[] }>()
);

export const loadSesionesFailure = createAction(
  '[FiltroBuscar API] Load Sesiones Fail',
  props<{ error: string }>()
);
